/**
 * お問い合わせフォームの画像アップロード全体バリデーター
 * 合計ファイル数と合計ファイルサイズをチェック
 */
export class ContactImagesValidator {
  private container: HTMLElement;
  private form: HTMLFormElement;
  private maxFiles: number;
  private maxFileSize: number;
  private maxTotalSize: number;

  constructor(container: HTMLElement) {
    this.container = container;

    // 親フォームを取得
    const form = container.closest('form');
    if (!form) {
      console.error('Form not found for ContactImagesValidator');
      return;
    }
    this.form = form;

    // data属性から設定を取得
    this.maxFiles = parseInt(container.dataset.maxFiles || '3', 10);
    this.maxFileSize = parseInt(container.dataset.maxFileSize || '2097152', 10); // 2MB
    this.maxTotalSize = parseInt(container.dataset.maxTotalSize || '6291456', 10); // 6MB

    this.init();
  }

  private init(): void {
    // フォーム送信時にバリデーション
    this.form.addEventListener('submit', (event) => {
      if (!this.validateImages()) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  /**
   * 画像のバリデーション
   * @returns バリデーション成功時true
   */
  private validateImages(): boolean {
    const fileInputs = this.container.querySelectorAll<HTMLInputElement>('input[type="file"][name^="contact_images"]');

    let fileCount = 0;
    let totalSize = 0;
    const files: File[] = [];

    // 全てのファイルinputをチェック
    fileInputs.forEach((input) => {
      if (input.files && input.files.length > 0) {
        const file = input.files[0];
        fileCount++;
        totalSize += file.size;
        files.push(file);
      }
    });

    // ファイル数チェック
    if (fileCount > this.maxFiles) {
      alert(`画像は最大${this.maxFiles}枚までアップロードできます。現在${fileCount}枚選択されています。`);
      return false;
    }

    // 合計サイズチェック
    if (totalSize > this.maxTotalSize) {
      const maxTotalMB = this.maxTotalSize / 1024 / 1024;
      const currentTotalMB = (totalSize / 1024 / 1024).toFixed(2);
      alert(`画像の合計サイズは最大${maxTotalMB}MBまでです。現在${currentTotalMB}MB選択されています。`);
      return false;
    }

    // 個別ファイルサイズチェック（念のため）
    for (const file of files) {
      if (file.size > this.maxFileSize) {
        const maxMB = this.maxFileSize / 1024 / 1024;
        const fileMB = (file.size / 1024 / 1024).toFixed(2);
        alert(`ファイル「${file.name}」のサイズが大きすぎます。1枚あたり最大${maxMB}MBまでです。（現在${fileMB}MB）`);
        return false;
      }
    }

    return true;
  }
}

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll<HTMLElement>('.js-contact-images-uploader');
  containers.forEach((container) => {
    new ContactImagesValidator(container);
  });
});
